import pageRef from '@shared/util/page-ref';

const useToggleState = (key: string) => {
  const state = pageRef(false, `useToggleState-${key}`);

  const setValue = (value: boolean) => {
    state.value = value;
  };

  const toggle = () => {
    state.value = !state.value;
  };

  return {
    state,
    setValue,
    toggle,
  };
};

export default useToggleState;
